<script setup>
  import { useTitle } from '@vueuse/core';
  import { watchEffect } from 'vue';
  import { useRoute } from 'vue-router';

  useProfileStore();

  const route = useRoute();
  const title = useTitle();

  watchEffect(() => {
    title.value = route.meta.title
      ? `MyScanSource - ${route.meta.title}`
      : 'MyScanSource';
  });

  onErrorCaptured((error) => {
    console.error('Error captured in App.vue', error);
    return false;
  });
</script>

<template>
  <RouterView />
</template>
